
export const userNav = [
    {url: '/users', label: 'User management', key: 'users.index', permissions: []},
]